;(function () {
  'use strict'

  angular
    .module('contrast.libraries')
    .directive('csLibraryBugtracker', csLibraryBugtracker)

  function csLibraryBugtracker() {
    return {
      restrict: 'E',
      controller: 'csLibraryBugtrackerCtrl',
      controllerAs: 'csLibraryBugtrackerCtrl',
      scope: {
        bugtrackers: '=',
        placement: '=',
        size: '='
      },
      bindToController: true,
      templateUrl: 'components-org/libraries/cs-library-bugtracker.html'
    }
  }
})()
